export const TitleNames = [
  {
    id: '1',
    name: 'นาย',
    sex: 0
  },
  {
    id: '2',
    name: 'นาง',
    sex: 1
  },
  {
    id: '3',
    name: 'นางสาว',
    sex: 1
  },
  {
    id: '4',
    name: 'Mr.',
    sex: 0
  },
  {
    id: '5',
    name: 'Mrs.',
    sex: 1
  },
  {
    id: '6',
    name: 'Miss',
    sex: 1
  },
  {
    id: '7',
    name: 'Ms.',
    sex: 1
  },
  {
    id: '8',
    name: 'Dr.'
  },
  {
    id: '9',
    name: 'คุณ'
  },
  {
    id: '10',
    name: 'ด.ช.',
    sex: 0
  },
  {
    id: '11',
    name: 'ด.ญ.',
    sex: 1
  },
  {
    id: '12',
    name: 'ม.จ.'
  },
  {
    id: '13',
    name: 'ม.จ.หญิง',
    sex: 1
  },
  {
    id: '14',
    name: 'ม.ร.ว.'
  },
  {
    id: '15',
    name: 'ม.ร.ว.หญิง',
    sex: 1
  },
  {
    id: '16',
    name: 'ม.ล.'
  },
  {
    id: '17',
    name: 'ม.ล.หญิง',
    sex: 1
  },
  {
    id: '18',
    name: 'หม่อม'
  },
  {
    id: '19',
    name: 'พระ'
  },
  {
    id: '20',
    name: 'ท่านผู้หญิง',
    sex: 1
  },
  {
    id: '21',
    name: 'คุณหญิง',
    sex: 1
  },
  {
    id: '22',
    name: 'ดร.'
  },
  {
    id: '23',
    name: 'ศ.'
  },
  {
    id: '24',
    name: 'รศ.'
  },
  {
    id: '25',
    name: 'ผศ.'
  },
  {
    id: '26',
    name: 'น.พ.',
    sex: 0
  },
  {
    id: '27',
    name: 'พ.ญ.',
    sex: 1
  },
  {
    id: '28',
    name: 'ท.พ.',
    sex: 0
  },
  {
    id: '29',
    name: 'ท.ญ.',
    sex: 1
  },
  {
    id: '30',
    name: 'พล.อ.'
  },
  {
    id: '31',
    name: 'พล.ท.'
  },
  {
    id: '32',
    name: 'พล.ต.'
  },
  {
    id: '33',
    name: 'พ.อ.'
  },
  {
    id: '34',
    name: 'พ.ท.'
  },
  {
    id: '35',
    name: 'พ.ต.'
  },
  {
    id: '36',
    name: 'ว่าที่ พ.อ.'
  },
  {
    id: '37',
    name: 'ว่าที่ พ.ท.'
  },
  {
    id: '38',
    name: 'ว่าที่ พ.ต.'
  },
  {
    id: '39',
    name: 'ส.อ.'
  },
  {
    id: '40',
    name: 'ส.ท.'
  },
  {
    id: '41',
    name: 'ส.ต.'
  },
  {
    id: '42',
    name: 'พ.อ.(พิเศษ)'
  },
  {
    id: '43',
    name: 'นนร.'
  },
  {
    id: '44',
    name: 'นนส.'
  },
  {
    id: '45',
    name: 'พล.ร.อ.'
  },
  {
    id: '46',
    name: 'พล.ร.ท.'
  },
  {
    id: '47',
    name: 'พล.ร.ต.'
  },
  {
    id: '48',
    name: 'พ.จ.อ.'
  },
  {
    id: '49',
    name: 'พ.จ.ท.'
  },
  {
    id: '50',
    name: 'พ.จ.ต.'
  },
  {
    id: '51',
    name: 'นนร.'
  },
  {
    id: '52',
    name: 'นรจ.'
  },
  {
    id: '53',
    name: 'พล.อ.อ.'
  },
  {
    id: '54',
    name: 'พล.อ.ท.'
  },
  {
    id: '55',
    name: 'พล.อ.ต.'
  },
  {
    id: '56',
    name: 'พ.อ.อ.'
  },
  {
    id: '57',
    name: 'พ.อ.ท.'
  },
  {
    id: '58',
    name: 'พ.อ.ต.'
  },
  {
    id: '59',
    name: 'น.อ.(พิเศษ)'
  },
  {
    id: '60',
    name: 'นนอ.'
  },
  {
    id: '61',
    name: 'นจอ.'
  },
  {
    id: '62',
    name: 'พล.ต.อ.'
  },
  {
    id: '63',
    name: 'พล.ต.ท.'
  },
  {
    id: '64',
    name: 'พล.ต.ต.'
  },
  {
    id: '65',
    name: 'พ.ต.อ.'
  },
  {
    id: '66',
    name: 'พ.ต.ท.'
  },
  {
    id: '67',
    name: 'พ.ต.ต.'
  },
  {
    id: '68',
    name: 'ว่าที่ พ.ต.อ.'
  },
  {
    id: '69',
    name: 'ว่าที่ พ.ต.ท.'
  },
  {
    id: '70',
    name: 'ว่าที่ พ.ต.ต.'
  },
  {
    id: '71',
    name: 'ร.ต.อ.'
  },
  {
    id: '72',
    name: 'ร.ต.ท.'
  },
  {
    id: '73',
    name: 'ร.ต.ต.'
  },
  {
    id: '74',
    name: 'ว่าที่ ร.ต.อ.'
  },
  {
    id: '75',
    name: 'ว่าที่ ร.ต.ท.'
  },
  {
    id: '76',
    name: 'ว่าที่ ร.ต.ต.'
  },
  {
    id: '77',
    name: 'ส.ต.อ.'
  },
  {
    id: '78',
    name: 'ส.ต.ท.'
  },
  {
    id: '79',
    name: 'ส.ต.ต.'
  },
  {
    id: '80',
    name: 'พ.ต.อ.(พิเศษ)'
  },
  {
    id: '81',
    name: 'ด.ต.'
  },
  {
    id: '82',
    name: 'นรต.'
  },
  {
    id: '83',
    name: 'นพต.'
  },
  {
    id: '84',
    name: 'น.อ.'
  },
  {
    id: '85',
    name: 'น.ท.'
  },
  {
    id: '86',
    name: 'น.ต.'
  },
  {
    id: '87',
    name: 'ว่าที่ น.อ.'
  },
  {
    id: '88',
    name: 'ว่าที่ น.ท.'
  },
  {
    id: '89',
    name: 'ว่าที่ น.ต.'
  },
  {
    id: '90',
    name: 'ร.อ.'
  },
  {
    id: '91',
    name: 'ร.ท.'
  },
  {
    id: '92',
    name: 'ร.ต.'
  },
  {
    id: '93',
    name: 'ว่าที่ ร.อ.'
  },
  {
    id: '94',
    name: 'ว่าที่ ร.ท.'
  },
  {
    id: '95',
    name: 'ว่าที่ ร.ต.'
  },
  {
    id: '96',
    name: 'จ.ส.อ.'
  },
  {
    id: '97',
    name: 'จ.ส.ท.'
  },
  {
    id: '98',
    name: 'จ.ส.ต.'
  },
  {
    id: '99',
    name: 'จ.อ.'
  },
  {
    id: '100',
    name: 'จ.ท.'
  },
  {
    id: '101',
    name: 'จ.ต.'
  },
  {
    id: '102',
    name: 'พลฯ'
  },
  {
    id: '103',
    name: 'จ.ส.'
  },
  {
    id: '104',
    name: 'พล ฯ สมัคร'
  },
  {
    id: '105',
    name: 'พล ฯ สำรอง'
  },
  {
    id: '106',
    name: 'พล ฯ สำรองพิเศษ'
  },
  {
    id: '107',
    name: 'พล ฯ พิเศษ'
  },
  {
    id: '108',
    name: 'อส.ทพ.'
  },
  {
    id: '109',
    name: 'พล.ต.หญิง',
    sex: 1
  },
  {
    id: '110',
    name: 'พ.อ.หญิง',
    sex: 1
  },
  {
    id: '111',
    name: 'พ.ท.หญิง',
    sex: 1
  },
  {
    id: '112',
    name: 'พ.ต.หญิง',
    sex: 1
  },
  {
    id: '113',
    name: 'ว่าที่ พ.อ.หญิง',
    sex: 1
  },
  {
    id: '114',
    name: 'ว่าที่ พ.ท.หญิง',
    sex: 1
  },
  {
    id: '115',
    name: 'ว่าที่ พ.ต.หญิง',
    sex: 1
  },
  {
    id: '116',
    name: 'ส.อ.หญิง',
    sex: 1
  },
  {
    id: '117',
    name: 'ส.ท.หญิง',
    sex: 1
  },
  {
    id: '118',
    name: 'ส.ต.หญิง',
    sex: 1
  },
  {
    id: '119',
    name: 'พ.อ.(พิเศษ)หญิง',
    sex: 1
  },
  {
    id: '120',
    name: 'ด.หญิง',
    sex: 1
  },
  {
    id: '121',
    name: 'พล.ร.ต.หญิง',
    sex: 1
  },
  {
    id: '122',
    name: 'พ.จ.อ.หญิง',
    sex: 1
  },
  {
    id: '123',
    name: 'พ.จ.ท.หญิง',
    sex: 1
  },
  {
    id: '124',
    name: 'พ.จ.ต.หญิง',
    sex: 1
  },
  {
    id: '125',
    name: 'น.อ.(พิเศษ)หญิง',
    sex: 1
  },
  {
    id: '126',
    name: 'พล.อ.ต.หญิง',
    sex: 1
  },
  {
    id: '127',
    name: 'พ.อ.อ.หญิง',
    sex: 1
  },
  {
    id: '128',
    name: 'พ.อ.ท.หญิง',
    sex: 1
  },
  {
    id: '129',
    name: 'พ.อ.ต.หญิง',
    sex: 1
  },
  {
    id: '130',
    name: 'น.อ.(พิเศษ)หญิง',
    sex: 1
  },
  {
    id: '131',
    name: 'พล.ต.ต.หญิง',
    sex: 1
  },
  {
    id: '132',
    name: 'พ.ต.อ.หญิง',
    sex: 1
  },
  {
    id: '133',
    name: 'พ.ต.ท.หญิง',
    sex: 1
  },
  {
    id: '134',
    name: 'พ.ต.ต.หญิง',
    sex: 1
  },
  {
    id: '135',
    name: 'ว่าที่ พ.ต.อ.หญิง',
    sex: 1
  },
  {
    id: '136',
    name: 'ว่าที่ พ.ต.ท.หญิง',
    sex: 1
  },
  {
    id: '137',
    name: 'ว่าที่ พ.ต.ต.หญิง',
    sex: 1
  },
  {
    id: '138',
    name: 'ร.ต.อ.หญิง',
    sex: 1
  },
  {
    id: '139',
    name: 'ร.ต.ท.หญิง',
    sex: 1
  },
  {
    id: '140',
    name: 'ร.ต.ต.หญิง',
    sex: 1
  },
  {
    id: '141',
    name: 'ว่าที่ ร.ต.อ.หญิง',
    sex: 1
  },
  {
    id: '142',
    name: 'ว่าที่ ร.ต.ท.หญิง',
    sex: 1
  },
  {
    id: '143',
    name: 'ว่าที่ ร.ต.ต.หญิง',
    sex: 1
  },
  {
    id: '144',
    name: 'ส.ต.อ.หญิง',
    sex: 1
  },
  {
    id: '145',
    name: 'ส.ต.ท.หญิง',
    sex: 1
  },
  {
    id: '146',
    name: 'ส.ต.ต.หญิง',
    sex: 1
  },
  {
    id: '147',
    name: 'พ.ต.อ.(พิเศษ)หญิง',
    sex: 1
  },
  {
    id: '148',
    name: 'ด.ต.หญิง',
    sex: 1
  },
  {
    id: '149',
    name: 'น.อ.หญิง',
    sex: 1
  },
  {
    id: '150',
    name: 'น.ท.หญิง',
    sex: 1
  },
  {
    id: '151',
    name: 'น.ต.หญิง',
    sex: 1
  },
  {
    id: '152',
    name: 'ว่าที่ น.อ.หญิง',
    sex: 1
  },
  {
    id: '153',
    name: 'ว่าที่ น.ท.หญิง',
    sex: 1
  },
  {
    id: '154',
    name: 'ว่าที่ น.ต.หญิง',
    sex: 1
  },
  {
    id: '155',
    name: 'ร.อ.หญิง',
    sex: 1
  },
  {
    id: '156',
    name: 'ร.ท.หญิง',
    sex: 1
  },
  {
    id: '157',
    name: 'ร.ต.หญิง',
    sex: 1
  },
  {
    id: '158',
    name: 'ว่าที่ ร.อ.หญิง',
    sex: 1
  },
  {
    id: '159',
    name: 'ว่าที่ ร.ท.หญิง',
    sex: 1
  },
  {
    id: '160',
    name: 'ว่าที่ ร.ต.หญิง',
    sex: 1
  },
  {
    id: '161',
    name: 'จ.ส.อ.หญิง',
    sex: 1
  },
  {
    id: '162',
    name: 'จ.ส.ท.หญิง',
    sex: 1
  },
  {
    id: '163',
    name: 'จ.ส.ต.หญิง',
    sex: 1
  },
  {
    id: '164',
    name: 'จ.อ.หญิง',
    sex: 1
  },
  {
    id: '165',
    name: 'จ.ท.หญิง',
    sex: 1
  },
  {
    id: '166',
    name: 'จ.ต.หญิง',
    sex: 1
  },
  {
    id: '167',
    name: 'พลฯหญิง',
    sex: 1
  },
  {
    id: '168',
    name: 'อส.หญิง',
    sex: 1
  },
  {
    id: '169',
    name: 'จ.ส.หญิง',
    sex: 1
  },
  {
    id: '170',
    name: 'พล ฯ สมัครหญิง',
    sex: 1
  },
  {
    id: '171',
    name: 'พล ฯ สำรองหญิง',
    sex: 1
  },
  {
    id: '172',
    name: 'พล ฯ สำรองพิเศษหญิง',
    sex: 1
  },
  {
    id: '173',
    name: 'พล ฯ พิเศษหญิง',
    sex: 1
  },
  {
    id: '174',
    name: 'ท่านผู้หญิง ม.ร.ว.หญิง',
    sex: 1
  },
  {
    id: '175',
    name: 'คุณหญิง พ.อ.หญิง',
    sex: 1
  },
  {
    id: '176',
    name: 'ศ. ดร.'
  },
  {
    id: '177',
    name: 'ศ. น.พ.',
    sex: 'นาย'
  },
  {
    id: '178',
    name: 'ศ. ร.ต.'
  },
  {
    id: '179',
    name: 'รศ. ดร.'
  },
  {
    id: '180',
    name: 'รศ. น.พ.',
    sex: 'นาย'
  },
  {
    id: '181',
    name: 'รศ. พ.ญ.',
    sex: 1
  },
  {
    id: '182',
    name: 'รศ. พ.จ.อ.'
  },
  {
    id: '183',
    name: 'รศ. ว่าที่ ร.ต.'
  },
  {
    id: '184',
    name: 'ผศ. ดร.'
  },
  {
    id: '185',
    name: 'ผศ. ท.พ.',
    sex: 0
  },
  {
    id: '186',
    name: 'ผศ. ท.ญ.',
    sex: 1
  },
  {
    id: '187',
    name: 'ผศ. ร.อ.หญิง',
    sex: 1
  },
  {
    id: '188',
    name: 'น.พ. ม.ร.ว.',
    sex: 0
  },
  {
    id: '189',
    name: 'น.พ. ม.ล.',
    sex: 0
  },
  {
    id: '190',
    name: 'น.พ. พ.ต.อ.',
    sex: 0
  },
  {
    id: '191',
    name: 'น.พ. ร.ท.',
    sex: 0
  },
  {
    id: '192',
    name: 'พ.ญ. ม.ล.หญิง',
    sex: 1
  },
  {
    id: '193',
    name: 'พ.ญ. คุณหญิง',
    sex: 1
  },
  {
    id: '194',
    name: 'ท.ญ. หม่อม',
    sex: 1
  },
  {
    id: '195',
    name: 'พล.อ. ม.ล.'
  },
  {
    id: '196',
    name: 'พล.อ. หลวง'
  },
  {
    id: '197',
    name: 'พล.ท. ม.จ.'
  },
  {
    id: '198',
    name: 'พล.ท. ม.ร.ว.'
  },
  {
    id: '199',
    name: 'พล.ท. ม.ล.'
  },
  {
    id: '200',
    name: 'พล.ท. หลวง'
  },
  {
    id: '201',
    name: 'พล.ท. น.พ.',
    sex: 0
  },
  {
    id: '202',
    name: 'พล.ต. ม.จ.'
  },
  {
    id: '203',
    name: 'พล.ต. ม.ร.ว.'
  },
  {
    id: '204',
    name: 'พล.ต. ม.ล.'
  },
  {
    id: '205',
    name: 'พล.ต. น.พ.',
    sex: 0
  },
  {
    id: '206',
    name: 'พ.อ. ม.จ.'
  },
  {
    id: '207',
    name: 'พ.อ. ม.ร.ว.'
  },
  {
    id: '208',
    name: 'พ.อ. ม.ล.'
  },
  {
    id: '209',
    name: 'พ.อ. หลวง'
  },
  {
    id: '210',
    name: 'พ.อ. ขุน'
  },
  {
    id: '211',
    name: 'พ.อ. ดร.'
  },
  {
    id: '212',
    name: 'พ.อ. น.พ.',
    sex: 0
  },
  {
    id: '213',
    name: 'พ.อ. พ.ญ.',
    sex: 1
  },
  {
    id: '214',
    name: 'พ.ท. ม.จ.'
  },
  {
    id: '215',
    name: 'พ.ท. ม.ร.ว.'
  },
  {
    id: '216',
    name: 'พ.ท. ม.ล.'
  },
  {
    id: '217',
    name: 'พ.ท. หลวง'
  },
  {
    id: '218',
    name: 'พ.ท. น.พ.',
    sex: 0
  },
  {
    id: '219',
    name: 'พ.ต. ม.จ.'
  },
  {
    id: '220',
    name: 'พ.ต. ม.ร.ว.'
  },
  {
    id: '221',
    name: 'พ.ต. ม.ล.'
  },
  {
    id: '222',
    name: 'พ.ต. หลวง'
  },
  {
    id: '223',
    name: 'พ.ต. น.พ.',
    sex: 0
  },
  {
    id: '224',
    name: 'พ.ต. พ.ญ.',
    sex: 1
  },
  {
    id: '225',
    name: 'ส.อ. ม.ร.ว.'
  },
  {
    id: '226',
    name: 'ส.อ. ม.ล.'
  },
  {
    id: '227',
    name: 'ส.ท. ม.ล.'
  },
  {
    id: '228',
    name: 'พ.อ.(พิเศษ)ม.ร.ว.'
  },
  {
    id: '229',
    name: 'พล.ร.อ. ม.จ.'
  },
  {
    id: '230',
    name: 'พล.ร.อ. ม.ร.ว.'
  },
  {
    id: '231',
    name: 'พล.ร.อ. หลวง'
  },
  {
    id: '232',
    name: 'พล.ร.ท. หลวง'
  },
  {
    id: '233',
    name: 'พล.ร.ต. ม.จ.'
  },
  {
    id: '234',
    name: 'พล.ร.ต. ม.ร.ว.'
  },
  {
    id: '235',
    name: 'พล.ร.ต. ม.ล.'
  },
  {
    id: '236',
    name: 'พล.ร.ต. หลวง'
  },
  {
    id: '237',
    name: 'พ.จ.อ. ม.ล.'
  },
  {
    id: '238',
    name: 'พล.อ.อ. ม.ร.ว.'
  },
  {
    id: '239',
    name: 'พล.อ.ท. ม.ร.ว.'
  },
  {
    id: '240',
    name: 'พล.อ.ท. ม.ล.'
  },
  {
    id: '241',
    name: 'พล.อ.ต. ม.ร.ว.'
  },
  {
    id: '242',
    name: 'พล.อ.ต. ม.ล.'
  },
  {
    id: '243',
    name: 'พล.อ.ต. น.พ.',
    sex: 0
  },
  {
    id: '244',
    name: 'พ.อ.อ. ม.ร.ว.'
  },
  {
    id: '245',
    name: 'พ.อ.อ. ม.ล.'
  },
  {
    id: '246',
    name: 'พล.ต.ท. หลวง'
  },
  {
    id: '247',
    name: 'พล.ต.ต. ม.ร.ว.'
  },
  {
    id: '248',
    name: 'พล.ต.ต. หลวง'
  },
  {
    id: '249',
    name: 'พล.ต.ต. น.พ.',
    sex: 0
  },
  {
    id: '250',
    name: 'พ.ต.อ. ม.จ.'
  },
  {
    id: '251',
    name: 'พ.ต.อ. ม.ร.ว.'
  },
  {
    id: '252',
    name: 'พ.ต.อ. ม.ล.'
  },
  {
    id: '253',
    name: 'พ.ต.อ. น.พ.',
    sex: 0
  },
  {
    id: '254',
    name: 'พ.ต.ท. ม.ร.ว.'
  },
  {
    id: '255',
    name: 'พ.ต.ท. ม.ล.'
  },
  {
    id: '256',
    name: 'พ.ต.ท. ดร.'
  },
  {
    id: '257',
    name: 'พ.ต.ท. น.พ.',
    sex: 0
  },
  {
    id: '258',
    name: 'พ.ต.ต. ม.ล.'
  },
  {
    id: '259',
    name: 'พ.ต.ต. น.พ.',
    sex: 0
  },
  {
    id: '260',
    name: 'ร.ต.อ. ม.ร.ว.'
  },
  {
    id: '261',
    name: 'ร.ต.อ. ม.ล.'
  },
  {
    id: '262',
    name: 'ร.ต.อ. ดร.'
  },
  {
    id: '263',
    name: 'ร.ต.อ. น.พ.',
    sex: 0
  },
  {
    id: '264',
    name: 'ร.ต.ต. ม.ล.'
  },
  {
    id: '265',
    name: 'ส.ต.อ. ม.ล.'
  },
  {
    id: '266',
    name: 'ส.ต.ท. ม.ล.'
  },
  {
    id: '267',
    name: 'ด.ต. ม.ล.'
  },
  {
    id: '268',
    name: 'น.อ. ม.จ.'
  },
  {
    id: '269',
    name: 'น.อ. ม.ร.ว.'
  },
  {
    id: '270',
    name: 'น.อ. ม.ล.'
  },
  {
    id: '271',
    name: 'น.อ. หลวง'
  },
  {
    id: '272',
    name: 'น.อ. ดร.'
  },
  {
    id: '273',
    name: 'น.อ. น.พ.',
    sex: 0
  },
  {
    id: '274',
    name: 'น.อ. ร.ต.'
  },
  {
    id: '275',
    name: 'น.ท. ม.ล.'
  },
  {
    id: '276',
    name: 'น.ท. หลวง'
  },
  {
    id: '277',
    name: 'น.ท. น.พ.',
    sex: 0
  },
  {
    id: '278',
    name: 'น.ต. ม.จ.'
  },
  {
    id: '279',
    name: 'น.ต. ม.ล.'
  },
  {
    id: '280',
    name: 'น.ต. ดร.'
  },
  {
    id: '281',
    name: 'น.ต. น.พ.',
    sex: 0
  },
  {
    id: '282',
    name: 'ร.อ. ม.ร.ว.'
  },
  {
    id: '283',
    name: 'ร.อ. ม.ล.'
  },
  {
    id: '284',
    name: 'ร.อ. หลวง'
  },
  {
    id: '285',
    name: 'ร.อ. ดร.'
  },
  {
    id: '286',
    name: 'ร.อ. น.พ.',
    sex: 0
  },
  {
    id: '287',
    name: 'ร.ท. ม.จ.'
  },
  {
    id: '288',
    name: 'ร.ท. ม.ล.'
  },
  {
    id: '289',
    name: 'ร.ท. ดร.'
  },
  {
    id: '290',
    name: 'ร.ท. น.พ.',
    sex: 0
  },
  {
    id: '291',
    name: 'ร.ต. ม.ร.ว.'
  },
  {
    id: '292',
    name: 'ร.ต. ม.ล.'
  },
  {
    id: '293',
    name: 'ร.ต. น.พ.',
    sex: 0
  },
  {
    id: '294',
    name: 'ว่าที่ ร.อ. น.พ.',
    sex: 0
  },
  {
    id: '295',
    name: 'ว่าที่ ร.ต. น.พ.',
    sex: 0
  },
  {
    id: '296',
    name: 'จ.ส.อ. ม.ร.ว.'
  },
  {
    id: '297',
    name: 'จ.ส.อ. ม.ล.'
  },
  {
    id: '298',
    name: 'พ.อ.หญิง ม.ล.หญิง',
    sex: 1
  },
  {
    id: '299',
    name: 'พ.อ.หญิง คุณหญิง',
    sex: 1
  },
  {
    id: '300',
    name: 'พ.อ.หญิง พ.ญ.',
    sex: 1
  },
  {
    id: '301',
    name: 'พ.อ.หญิง ท.ญ.',
    sex: 1
  },
  {
    id: '302',
    name: 'พ.ท.หญิง คุณหญิง',
    sex: 1
  },
  {
    id: '303',
    name: 'พ.จ.อ.หญิง ม.ล.หญิง',
    sex: 1
  },
  {
    id: '304',
    name: 'พ.ต.อ.หญิง ม.ร.ว.หญิง',
    sex: 1
  },
  {
    id: '305',
    name: 'พ.ต.อ.หญิง พ.ญ.',
    sex: 1
  },
  {
    id: '306',
    name: 'พ.ต.ต.หญิง พ.ญ.',
    sex: 1
  },
  {
    id: '307',
    name: 'ร.ต.ต.หญิง พ.ญ.',
    sex: 1
  },
  {
    id: '308',
    name: 'น.อ.หญิง ม.ล.หญิง',
    sex: 1
  },
  {
    id: '309',
    name: 'น.อ.หญิง พ.ญ.',
    sex: 1
  },
  {
    id: '310',
    name: 'น.ท.หญิง ม.ล.หญิง',
    sex: 1
  },
  {
    id: '311',
    name: 'น.ท.หญิง พ.ญ.',
    sex: 1
  },
  {
    id: '312',
    name: 'น.ต.หญิง ม.ล.หญิง',
    sex: 1
  },
  {
    id: '313',
    name: 'น.ต.หญิง พ.ญ.',
    sex: 1
  },
  {
    id: '314',
    name: 'ร.อ.หญิง ม.ร.ว.หญิง',
    sex: 1
  },
  {
    id: '315',
    name: 'ร.อ.หญิง ม.ล.หญิง',
    sex: 1
  },
  {
    id: '316',
    name: 'ร.อ.หญิง พ.ญ.',
    sex: 1
  },
  {
    id: '317',
    name: 'ร.ท.หญิง ม.ล.',
    sex: 1
  },
  {
    id: '318',
    name: 'ร.ต.หญิง ม.ล.หญิง',
    sex: 1
  },
  {
    id: '319',
    name: 'ร.ต.หญิง พ.ญ.',
    sex: 1
  },
  {
    id: '320',
    name: 'จ.อ.หญิง ม.ล.หญิง',
    sex: 1
  }
];

export const ListMale = TitleNames.filter(i => i.sex === 0).map(i => i.name);
export const ListFemale = TitleNames.filter(i => i.sex === 1).map(i => i.name);
